import script from "./cpt-drawarea.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-drawarea.vue?vue&type=script&setup=true&lang=js"

import "./cpt-drawarea.vue?vue&type=style&index=0&id=bb8bc784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8bc784"]])

export default __exports__